<template>
    <div>
        <div class="text-center">
            <h3 class="mb-3">Risk and Reward</h3>
            <p>Control the potential risk before entering any position by using our risk and reward calculator. With this tool, you can calculate the positions best target and the corresponding reward to risk ratios. Just specify the entry, stop loss and take profit price.</p>
        </div> 
        <!-- <ul class="listResult d-flex flex-wrap text-left">
            <li>
                <p>Segment</p>
                <h4>0.0</h4>
            </li>
            <li>
                <p>Account base currency</p>
                <h4>0.0</h4>
            </li>
            <li>
                <p>Symbol</p>
                <h4>EURUSD</h4>
            </li>
            <li>
                <p>Volume in lots</p>
                <h4>500</h4>
            </li>
            <li>
                <p>Current Conversion Price</p>
                <h4>0.0</h4>
            </li>
        </ul> -->

    </div>
</template>
<script>
    export default {
        name: 'Riskrewards',
        data() {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/risk_rewards.vue